import axios from 'axios';

import { getErrorString } from '../../../../util/normalize-errors';
import getLogger from '../../../../util/logger';
import { isRosterIdentity } from '../../../../util/identity';

const logger = getLogger('selfie-station-actions');

export const SELFIE_STATION_SET_ENTITY =
  'selfie-station/SELFIE_STATION_SET_ENTITY';
export const SELFIE_STATION_RESET = 'selfie-station/SELFIE_STATION_RESET';
export const SELFIE_STATION_UPLOAD_SELFIE_REQUEST =
  'selfie-station/SELFIE_STATION_UPLOAD_SELFIE_REQUEST';
export const SELFIE_STATION_UPLOAD_SELFIE_SUCCESS =
  'selfie-station/SELFIE_STATION_UPLOAD_SELFIE_SUCCESS';
export const SELFIE_STATION_UPLOAD_SELFIE_FAILURE =
  'selfie-station/SELFIE_STATION_UPLOAD_SELFIE_FAILURE';

export const setEntity = entity => ({
  type: SELFIE_STATION_SET_ENTITY,
  entity,
});

export const resetSelfieStation = () => ({
  type: SELFIE_STATION_RESET,
});

const uploadSelfieRequest = () => ({
  type: SELFIE_STATION_UPLOAD_SELFIE_REQUEST,
});

const uploadSelfieSuccess = () => ({
  type: SELFIE_STATION_UPLOAD_SELFIE_SUCCESS,
});

const uploadSelfieFailure = error => ({
  type: SELFIE_STATION_UPLOAD_SELFIE_FAILURE,
  error: getErrorString(error),
});

/**
 * Uploads a new identity selfie from Selfie Station.
 *
 * @param {Object} opts The options object.
 * @param {String} opts.identity The Identity to be updated.
 * @param {File} opts.selfie The photo file to be uploaded.
 * @param {Account} opts.account The logged in account uploading the photo & info.
 * @param {function} opts.updateSelfieMutation GraphQL UpdateSelfie mutation.
 * @param {function} opts.photosUploadMutation GraphQL Photo Upload Mutation.
 * @param {function} opts.updateRosterIdentityMutation
 */
export const uploadSelfie = ({
  identity,
  selfie,
  account,
  updateSelfieMutation,
  updateRosterIdentityMutation,
  photosUploadMutation,
}) => async dispatch => {
  dispatch(uploadSelfieRequest());

  logger.info('uploadSelfie :: Selfie to upload: ', selfie);

  try {
    const photoUploadsRes = await photosUploadMutation(account.id, [
      { filename: selfie.name, content_type: selfie.type },
    ]);

    const [photoUploadData] = photoUploadsRes.data.photosUpload.photo_uploads;

    logger.info('uploadSelfie :: photoUploadRes: ', photoUploadData);

    const res = await axios.put(photoUploadData.upload_url, selfie, {
      headers: {
        'Content-Type': selfie.type,
      },
    });

    logger.info('uploadSelfie :: axios res: ', res);

    if (isRosterIdentity(identity)) {
      await updateRosterIdentityMutation({
        rosterIdentityId: identity.id,
        selfiePhotoId: photoUploadData.photo_id,
      });
    } else {
      await updateSelfieMutation({
        identityId: identity.id,
        photoId: photoUploadData.photo_id,
      });
    }

    logger.info('uploadSelfie :: Upload process completed');

    dispatch(uploadSelfieSuccess());
  } catch (error) {
    logger.error('updateSelfie :: Error during selfie upload: ', error);
    dispatch(uploadSelfieFailure(error));
  }
};
